import React, { useRef } from 'react';
import { BetManager, useApplicationState, useHighlightedOutcome } from '@apollo/core';
import cx from 'classnames';
import Odds from '../../shared/components/Odds';
import { oddsAnimation } from '../../core/utils';

const BespokeOutcome = ({ market, outcome, disabled }) => {
  const { selected } = useHighlightedOutcome(outcome.id);
  const { layout } = useApplicationState();
  const outcomeBox = useRef(null);

  const addToBet = (market, outcome) => {
    if (disabled) {
      return null;
    }

    if (layout.mobileDevice && outcomeBox.current && !selected) {
      oddsAnimation(outcomeBox.current, true, Number(outcome.odds)?.toFixed(2));
    }

    BetManager.selectBet({
      betEventType: market.sportService,
      event: market.event,
      eventId: market.eventId,
      marketTypeId: market.name,
      marketId: market.id,
      outcomeId: outcome.id,
      isBespokeOutcome: true,
      betGroups: [0],
      isNew: true,
    });
  };

  const oddClassName = cx('main-market__outcome event__outcome bespoke-outcome__btn btn btn-bet', {
    selected,
    disabled,
  });

  return (
    <div className='bespoke-outcome'>
      <div className='market--default odd-wrapper'>
        <div className='odd-wrapper__content'>
          <div className='bespoke-outcome__text-container'>
            <span className='bespoke-outcome__name'>
              <span>{outcome.localizedName}</span>
              <span
                ref={outcomeBox}
                className={oddClassName}
                onClick={() => addToBet(market, outcome)}
              >
                <Odds value={outcome.odds} decimal={3} minDecimal={2} />
              </span>
            </span>
            <span className='bespoke-outcome__description'>{outcome.localizedDescription}</span>
          </div>
          <span className={oddClassName} onClick={() => addToBet(market, outcome)}>
            <Odds value={outcome.odds} decimal={3} minDecimal={2} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default BespokeOutcome;
